import React from "react";
import { ORG } from "../../data/costant";
import { Link } from "react-router-dom";
import { checkToken } from "../../utils/Auth";

export default function Footer() {
  const token = checkToken();
  return (
    <div
      className="container-fluid bg-dark text-light footer pt-5 wow fadeIn"
      data-wow-delay="0.1s"
      style={{ marginTop: "6rem" }}
    >
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-3 col-md-6">
            <h4 className="text-light mb-4">Address</h4>
            <p className="mb-2">
              <i className="fa fa-map-marker-alt me-3"></i>{ORG.address}
            </p>
            <p className="mb-2">
              <i className="fa fa-phone-alt me-3"></i>+91 {ORG.mobile}
            </p>
            <p className="mb-2">
              <i className="fa fa-envelope me-3"></i>{ORG.email}
            </p>
          </div>
          <div className="col-lg-3 col-md-6">
            <h4 className="text-light mb-4">Quick Links</h4>
            <Link className="btn btn-link" to={"/"}>
              Home
            </Link>
            <Link className="btn btn-link" to={"/newQuote"}>
              New Qoute
            </Link>
            <Link className="btn btn-link" to={"/aboutus"}>
              About Us
            </Link>
            <Link className="btn btn-link" to={"/contact"}>
              Contact Us
            </Link>
            <Link className="btn btn-link" to={"/services"}>
              Services
            </Link>
            <Link className="btn btn-link" to={"/pricing"}>
              Pricing
            </Link>
            {!token &&
              <>
                <Link className="btn btn-link" to={"/login"}>
                  Login
                </Link>
                <Link className="btn btn-link" to={"/register"}>
                  Register
                </Link>
              </>
            }
          </div>
          <div className="col-lg-3 col-md-6">
            <h4 className="text-light mb-4">Policies</h4>
            <Link className="btn btn-link" to={"/terms"}>
              Terms & Condition
            </Link>
            <Link className="btn btn-link" to={"/privacyPolicy"}>
              Privacy Policy
            </Link>
            <Link className="btn btn-link" to={"/refundPolicy"}>
              Refund and Cancellation
            </Link>
            <Link className="btn btn-link" to={"/termsofuse"}>
              Terms of Use
            </Link>
            <Link className="btn btn-link" to={"/termsofshipping"}>
              Terms of Shipping
            </Link>
            <Link className="btn btn-link" to={"/disclaimer"}>
              Disclaimer of Warranties
            </Link>
            <Link className="btn btn-link" to={"/restrictions"}>
              Restrictions
            </Link>
          </div>
          <div className="col-lg-3 col-md-6">
            <h4 className="text-light mb-4">Newsletter</h4>
            <p>Join our mailing list for the latest news, offers, and insights from logistics and transport.</p>
            <div
              className="position-relative mx-auto"
              style={{ maxWidth: "400px" }}
            >
              <input
                className="form-control border-0 w-100 py-3 ps-4 pe-5"
                type="text"
                placeholder="Your email"
              />
              <button
                type="button"
                className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
              >
                SignUp
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="copyright">
          <div className="row">
            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
              &copy;
              <Link className="border-bottom" to={"/"}>
                {ORG.name}
              </Link>
              , All Right Reserved.
            </div>

          </div>
        </div>
      </div>
      <a
        href="#"
        className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top"
      >
        <i className="bi bi-arrow-up"></i>
      </a>
    </div>
  );
}
